// src/views/Pines/ListaPines.jsx
import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";

import useEscClose from "../../useEscClose";
import GenerarPines from "./GenerarPines";
import FiltroPines from "./FiltroPines";
import EditarPines from "./EditarPines";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

// 🧩 COMPONENTES STANDARD
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";

const DEFAULT_PAGE_SIZE = 30;

/**
 * Vista principal de Pines
 */
export default function ListaPines() {
  return <ListaPinesTabla />;
}

/**
 * Vista de listado
 */
function ListaPinesTabla() {
  // ============================
  //        LISTADO
  // ============================
  const [items, setItems] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [porPagina, setPorPagina] = useState(DEFAULT_PAGE_SIZE);
  const [totalBackend, setTotalBackend] = useState(0);
  const [cargando, setCargando] = useState(false);

  // ============================
  //        FILTROS
  // ============================
  const [filtros, setFiltros] = useState({});
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  useEscClose(() => setMostrarFiltros(false), mostrarFiltros);

  const limpiarSeleccion = () => {
    const empty = {};
    setFiltros(empty);
    setPaginaActual(1);
    fetchPines(0, porPagina, empty);
  };

  // ============================
  //        EDITAR PIN
  // ============================
  const [showEdit, setShowEdit] = useState(false);
  const [pinIdEdit, setPinIdEdit] = useState(null);
  useEscClose(() => setShowEdit(false), showEdit);

  // ============================
  //     GENERAR PINES (MODAL)
  // ============================
  const [showGenerar, setShowGenerar] = useState(false);
  useEscClose(() => setShowGenerar(false), showGenerar);

  // ============================
  //        FETCH BACKEND
  // ============================
  const fetchPines = async (
    pageIndex = paginaActual - 1,
    size = porPagina,
    filtrosAplicados = filtros
  ) => {
    setCargando(true);

    try {
      const params = new URLSearchParams();
      params.append("page", pageIndex);
      params.append("size", size);

      Object.entries(filtrosAplicados).forEach(([key, value]) => {
        if (value !== null && value !== undefined && String(value) !== "") {
          params.append(key, value);
        }
      });

      const data = await appFetchJson(
        `${apiRoutes.pines.list}?${params.toString()}`
      );

      const content = data?.items || data?.content || [];
      const total =
        data?.totalElements ??
        data?.total ??
        content.length;

      setItems(content);
      setTotalBackend(total);
    } catch (error) {
      console.error("Error al cargar pines:", error);
      setItems([]);
      setTotalBackend(0);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchPines(0, porPagina, filtros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ============================
  //        PAGINACIÓN
  // ============================
  const cambiarPagina = (num) => {
    setPaginaActual(num);
    fetchPines(num - 1, porPagina, filtros);
  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="page">
      {/* =========================
          HEADER STANDARD
         ========================= */}
      <ListHeader
        title="Lista Pines de Clientes"
        onFilterClick={() => setMostrarFiltros(true)}
        filters={filtros}
        onClearFilters={limpiarSeleccion}
        showAdd
        addLabel="Generar Pines"
        onAddClick={() => setShowGenerar(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPaginaActual(1);
          fetchPines(0, size, filtros);
        }}
      />

      {/* =========================
          FILTROS
         ========================= */}
      {mostrarFiltros && (
        <FiltroPines
          initialFilters={filtros}
          onSubmit={(nuevosFiltros) => {
            setFiltros(nuevosFiltros);
            setPaginaActual(1);
            setMostrarFiltros(false);
            fetchPines(0, porPagina, nuevosFiltros);
          }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      {/* =========================
          MODALES
         ========================= */}
      {showGenerar && (
        <GenerarPines
          onClose={() => setShowGenerar(false)}
          onSaved={() => {
            setShowGenerar(false);
            fetchPines(paginaActual - 1, porPagina, filtros);
          }}
        />
      )}

      {showEdit && (
        <EditarPines
          id={pinIdEdit}
          onClose={() => setShowEdit(false)}
          onSaved={() =>
            fetchPines(paginaActual - 1, porPagina, filtros)
          }
        />
      )}

      {/* =========================
          TABLA
         ========================= */}
      <div className="overflow-x-auto mt-4">
        <table className="table-card">
          <thead className="table-head">
            <tr>
              <th className="cell text-left w-28">Nro. Responsable</th>
              <th className="cell text-right w-24">Nro. de PIN</th>
              <th className="cell text-left">Tipo</th>
              <th className="cell text-right">Cliente</th>
              <th className="cell text-left">Responsable</th>
              <th className="cell text-left">Documento</th>
              <th className="cell text-left">Estado</th>
              <th className="cell-center">Acción</th>
            </tr>
          </thead>

          <tbody>
            {cargando ? (
              <tr>
                <td colSpan={10} className="cell text-center">
                  Cargando...
                </td>
              </tr>
            ) : items.length === 0 ? (
              <tr>
                <td colSpan={10} className="cell text-center">
                  Sin resultados
                </td>
              </tr>
            ) : (
              items.map((row, index) => (
                <tr
                  key={row.id}
                  className={index % 2 === 0 ? "row-alt" : "bg-white"}
                >
                  <td className="cell">{row.numeroResponsable}</td>
                  <td className="cell text-right">{String(row.numero).padStart(4, "0")}</td>
                  <td className="cell">{row.tipo}</td>
                  <td className="cell text-right">{row.clienteNombre}</td>
                  <td className="cell">{row.descripcionResponsable}</td>
                  <td className="cell">{row.numeroDocumento}</td>
                  <td className="cell">{row.estadoNombre}</td>

                  <td className="cell-center">
                    <button
                      className="icon-btn"
                      title="Editar"
                      onClick={() => {
                        setPinIdEdit(row.id);
                        setShowEdit(true);
                      }}
                    >
                      <FaEdit />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* =========================
          FOOTER STANDARD
         ========================= */}
      <ListFooter
        page={paginaActual}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={cambiarPagina}
      />
    </div>
  );
}
